import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = []

const defaultSyntaxGuideUrl = ''

class EuropePmc extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Europe PMC')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }

  formulateQuery (query) {
    return 'https://europepmc.org/search?query=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default EuropePmc



// WEBPACK FOOTER //
// ./src/formulate_queries/EuropePmcEngine.js